module.exports = __webpack_public_path__ + "content/img/loading.f39295cc.gif";